export default __webpack_public_path__ + "ce03f25ae06039fb2950e48ae1351253.svg";